<div class="container" style="text-align:center;">
    <h1>Willkommen bei {{ title }}</h1>
</div>
